"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isImage = void 0;
/* Type Guards */
var isImage = function (image) {
  return image.fluid === undefined;
};
exports.isImage = isImage;
exports.default = exports.isImage;